import { connect } from 'react-redux';
import { RouteWithAuth } from './RouteWithAuth.component';

export default connect()(RouteWithAuth);
